import { render, staticRenderFns } from "./sharedSpaceDetail.vue?vue&type=template&id=7d09d24a&"
import script from "./sharedSpaceDetail.vue?vue&type=script&lang=js&"
export * from "./sharedSpaceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports